var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"show":_vm.isVisible,"fade":"","dismissible":"","variant":"success","role":"alert"},on:{"dismissed":function($event){_vm.isVisible = false}}},[_vm._v("\n  Novo Produto: "+_vm._s(_vm.productData.description)+" - #"+_vm._s(_vm.productData.base_sku_id)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }